"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.UnauthHeader = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const material_1 = require("@mui/material");
const react_1 = require("react");
const react_router_dom_1 = require("react-router-dom");
exports.UnauthHeader = (0, react_1.memo)(() => {
    const theme = (0, material_1.useTheme)();
    const navigate = (0, react_router_dom_1.useNavigate)();
    const handleSignIn = (0, react_1.useCallback)(() => {
        navigate("/sign-in");
    }, [navigate]);
    const handleSignUp = (0, react_1.useCallback)(() => {
        navigate("/sign-up");
    }, [navigate]);
    return ((0, jsx_runtime_1.jsxs)(material_1.Stack, { direction: "row", spacing: 4, alignItems: "center", height: "100%", width: "100%", justifyContent: "flex-end", padding: 2, children: [(0, jsx_runtime_1.jsx)(material_1.Typography, { variant: "h6", color: "primary.contrastText", fontWeight: theme.typography.fontWeightMedium, style: { cursor: "pointer" }, onClick: handleSignIn, children: "Sign in" }), (0, jsx_runtime_1.jsx)(material_1.Typography, { variant: "h6", color: "primary.contrastText", fontWeight: theme.typography.fontWeightMedium, style: { cursor: "pointer" }, onClick: handleSignUp, children: "Sign up" })] }));
});
exports.UnauthHeader.displayName = "UnauthHeader";
